import React from "react";
import axios from "../../../../axios";
import useUnsavedChangesWarning from "./useUnsavedChangesWarning";
import assets from "../../../../assets/assets";

function SubmittingWithoutAnsweringPopup({
  setUnAnsweredPopup,
  questionsAnswer,
  userId,
  assessmentId,
  didPressExit,
  unAttemptedTitles
}) {
  const [Prompt, setFalse] = useUnsavedChangesWarning();
  let data = JSON.parse(localStorage.getItem("breathForStudent"));

  const handleSubmit = async () => {
    try {
      setFalse();
      const arrayToSubmit = questionsAnswer.map((obj) => {
        if (obj?.answer?.key && obj?.answer?.key === "") {
          return { ...obj, answer: { ...obj.answer, key: " " } };
        } else if (obj?.description && obj?.description === "") {
          return { ...obj, description: " " };
        } else {
          return obj;
        }
      });

      let res = await axios.post(
        `/assessment/${assessmentId}/studentResponse/create`,
        {
          student_id: userId,
          submitted_on: new Date(),
          answers: arrayToSubmit,
        }
      );
      if (res) {
        setUnAnsweredPopup(false);
        window.close();
      }

    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="ContainerSubmitedSucess ">
      <div className="SubContainerSubmitedSucess">
        <div
          onClick={() => {
            setUnAnsweredPopup(false);
          }}
          style={{ cursor: "pointer" }}
          className="d-flex align-items-center"
        >
          <img src={assets.CrossIcon} className="w-8 absolute right-2" alt="icon" />
        </div>
        <div className="">
          <h3>Unattempted Questions</h3>
          <div className="text-lg ml-2">
            {unAttemptedTitles.map((q) => {
              return (
                <div className="flex gap-2">{q}</div>
              )
            })}
          </div>

        </div>

        <div className="d-flex justify-content-around align-items-center mt-3 widthOfContainer">

          <button
            className="okayBtnsucessBack"
            onClick={() => {
              setUnAnsweredPopup(false);
            }}
          >
            Cancel
          </button>
          <button
            className="okayBtnsucessBack"
            onClick={() => {
              handleSubmit();
            }}
          >
            Continue to Submit
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubmittingWithoutAnsweringPopup;
